import PortfolioAutoTradeDetail from './PortfolioAutoTradeDetail';

export default PortfolioAutoTradeDetail;
